export interface PasswordStrengthResult {
  strength: number
  is_strong: boolean
  feedback: string[]
  required_checks: number
  passed_checks: number
}

export function checkPasswordStrength(password: string): PasswordStrengthResult {
  const feedback: string[] = []
  let strength = 0

  const minLength = 12
  const requireUppercase = true
  const requireLowercase = true
  const requireNumbers = true
  const requireSymbols = true

  if (password.length >= minLength) {
    strength += 1
  } else {
    feedback.push(`Password must be at least ${minLength} characters long`)
  }

  if (requireUppercase) {
    if (/[A-Z]/.test(password)) {
      strength += 1
    } else {
      feedback.push('Password must contain at least one uppercase letter')
    }
  }

  if (requireLowercase) {
    if (/[a-z]/.test(password)) {
      strength += 1
    } else {
      feedback.push('Password must contain at least one lowercase letter')
    }
  }

  if (requireNumbers) {
    if (/[0-9]/.test(password)) {
      strength += 1
    } else {
      feedback.push('Password must contain at least one number')
    }
  }

  if (requireSymbols) {
    if (/[^A-Za-z0-9]/.test(password)) {
      strength += 1
    } else {
      feedback.push('Password must contain at least one special character')
    }
  }

  const commonPasswords = [
    'password',
    '123456',
    '123456789',
    'qwerty',
    'abc123',
    'password123',
    'admin',
    'letmein',
    'welcome',
    'monkey',
  ]

  if (commonPasswords.includes(password.toLowerCase())) {
    strength = 0
    feedback.push('Password is too common, please choose a stronger password')
  }

  const requiredChecks = 1 + (requireUppercase ? 1 : 0) + (requireLowercase ? 1 : 0) + (requireNumbers ? 1 : 0) + (requireSymbols ? 1 : 0)

  return {
    strength,
    is_strong: strength >= requiredChecks,
    feedback,
    required_checks: requiredChecks,
    passed_checks: strength,
  }
}
